import classNames from 'classnames';

import { useTransparentPatternStyles } from 'hooks/browser/styles';

interface IProps {
  colors: string[];
  isSelected: boolean;
}

export const ColorPreview = ({ colors, isSelected }: IProps) => {
  const { styles } = useTransparentPatternStyles({ colors });

  return (
    <div
      className={classNames(
        'h-6 w-6 rounded-sm outline outline-1 outline-black/20 dark:outline-white/20',
        {
          '!outline-2 !outline-carnationRed': isSelected,
        },
      )}
      style={styles}
    ></div>
  );
};
